import { render, staticRenderFns } from "./DepositEventSwiper.vue?vue&type=template&id=07bcc61a"
import script from "./DepositEventSwiper.vue?vue&type=script&lang=js"
export * from "./DepositEventSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports